import { Divider } from 'antd';
import * as React from 'react';
import { IDividerProps } from './entities';

const BCDivider: React.FC<IDividerProps> = React.memo(props => (
	<Divider
		className={props.className}
		type={props.type}
		style={props.styles}
	/>
));

export { IDividerProps };
export default BCDivider;
